"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialFarm = initialFarm;

function initialFarm() {
  return {
    id: null,
    // first part farm address fields
    salutation: '',
    first_name: '',
    last_name: '',
    street: '',
    zip: '',
    city: '',
    canton: {},
    telephone: '',
    mobile: '',
    email: '',
    ispublishedemail: false,
    farm_has_no_email: false,
    website: '',
    latitude: '',
    longitude: '',
    // second part farm data
    farmname: '',
    slogan: '',
    mainlanguage: {},
    otherlanguages: [],
    directions: '',
    directionspublictransport: '',
    farmdescription: '',
    acreage: '',
    productiontype: {},
    amountofworkers: '',
    animals: [],
    animalsextended: '',
    cultures: [],
    culturesextended: '',
    acquisitiontype: {},
    operatingmode: {},
    zones: [],
    productionlabels: [],
    programs: [],
    regionalattractions: '',
    comment: '',
    images: [],
    documents: [],
    mainImage: {},
    facebook_link: '',
    instagram_link: '',
    twitter_link: '',
    youtube_link: ''
  };
}


//////////////////
// WEBPACK FOOTER
// ./client/components/farm/lib/farm.js
// module id = 170
// module chunks = 0